import React from 'react';

// DEPENDENCIES
import clsx from 'clsx';

// VARIABLES
import { DELIVERY_LOG_STATUS } from 'codes';

// MAIN COMPONENT
const StatusCell = ({
  placeholder, //
  row: { original } = {},
  value
}) => {
  const isBackout = original?.current_status?.status_code === DELIVERY_LOG_STATUS.Backout.code;

  return value ? <div className={clsx('text-center', isBackout && 'text-danger')}>{value}</div> : placeholder;
};

// EXPORT
export default StatusCell;
